import { omit } from 'lodash';

export const transformUrl = (url) => {
  if (url.indexOf('http') === 0) return url;

  return `https://${url}`;
};

export const replaceLastPathSegments = (url, segmentsAmount, newSegment) => {
  const base = url.split('/').slice(0, -segmentsAmount).join('/');
  if (newSegment) {
    return `${base}/${newSegment}`;
  }
  return base;
};

export const replaceLastPathSegment = (url, newSegment) => {
  return replaceLastPathSegments(url, 1, newSegment);
};

export function removeQueryParam(url, paramKey) {
  if (!url || typeof url !== 'string') return url;
  const [baseUrl, queryString] = url.split('?');

  if (!queryString) return url;

  const searchParams = new URLSearchParams(queryString);
  const params = Object.fromEntries(searchParams.entries());
  const filteredParams = omit(params, [paramKey]);

  const newQueryString = new URLSearchParams(filteredParams).toString();
  return newQueryString ? `${baseUrl}?${newQueryString}` : baseUrl;
}
